<template>
  <v-row no-gutters>
    <v-col>
      <div id="root-list" :class="{ 'page-fullscreen': pageStore.isFullScreen }">
        <v-card
          tile
          :class="$vuetify.breakpoint.mdAndDown ? null : 'rounded-t-xl'"
          :disabled="rootStore.listDisabled"
        >
          <PageHeader>
            <template #action>
              <AddEdit />
            </template>
          </PageHeader>

          <v-data-table
            :headers="tableColumns"
            :items="rootStore.tableItems"
            :loading="rootStore.tableLoading"
            loader-height="2"
            :items-per-page="-1"
            :mobile-breakpoint="100"
            :height="pageStore.tableHeight"
            fixed-header
            hide-default-footer
          >
            <!--  Arama -->
            <template v-slot:body.prepend>
              <tr style="zoom: 0.8">
                <td class="pa-0">
                  <v-text-field
                    v-model="rootSearch"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    placeholder="Ara"
                    filled
                    class="rounded-0 elevation-0"
                    hide-details
                  ></v-text-field>
                </td>

                <td class="pa-0">
                  <v-select
                    v-model="daySearch"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    :items="[
                      { text: 'Hepsi', value: '' },
                      { text: '*', value: '1' },
                      { text: 'Sarf', value: '2' },
                      { text: 'Mamul', value: '3' },
                    ]"
                    placeholder="Ara"
                    filled
                    class="rounded-0 elevation-0"
                    hide-details
                    attach
                    :menu-props="{ bottom: true, offsetY: true }"
                  ></v-select>
                </td>

                <td class="pa-0">
                  <v-select
                    v-model="daySearch"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    :items="[
                      { text: 'Hepsi', value: '' },
                      { text: 'Pazertesi', value: '1' },
                      { text: 'Salı', value: '2' },
                      { text: 'Çarşamba', value: '3' },
                      { text: 'Perşembe', value: '4' },
                      { text: 'Cuma', value: '5' },
                      { text: 'Cumartesi', value: '6' },
                      { text: 'Pazar', value: '0' },
                    ]"
                    placeholder="Ara"
                    filled
                    class="rounded-0 elevation-0"
                    hide-details
                    attach
                    :menu-props="{ bottom: true, offsetY: true }"
                  ></v-select>
                </td>

                <td class="pa-0">
                  <v-text-field
                    filled
                    disabled
                    class="rounded-0 elevation-0"
                    hide-details
                  ></v-text-field>
                </td>
                <td class="pa-0">
                  <v-text-field
                    filled
                    disabled
                    class="rounded-0 elevation-0"
                    hide-details
                  ></v-text-field>
                </td>
                <td class="pa-0">
                  <v-text-field
                    filled
                    disabled
                    class="rounded-0 elevation-0"
                    hide-details
                  ></v-text-field>
                </td>
                <td class="pa-0">
                  <v-text-field
                    filled
                    disabled
                    class="rounded-0 elevation-0"
                    hide-details
                  ></v-text-field>
                </td>
                <td class="pa-0">
                  <v-text-field
                    filled
                    disabled
                    class="rounded-0 elevation-0"
                    hide-details
                  ></v-text-field>
                </td>
              </tr>
            </template>

            <template #[`item.orderdays`]="{ item }">
              <v-chip-group>
                <v-chip
                  v-for="(element, index) in orderDays(item.orderdays)"
                  :key="`${index}-key`"
                  class="mr-2"
                  label
                  :color="element === 'Cumartesi' || element === 'Pazar' ? 'warning' : 'secondary'"
                  :outlined="element === 'Cumartesi' || element === 'Pazar'"
                  small
                >
                  {{ element }}
                </v-chip>
              </v-chip-group>
            </template>
            <template #[`item.openhour`]="{ item }">
              {{ item.openhour.slice(0, 5) }}
            </template>
            <template #[`item.closehour`]="{ item }">
              {{ item.closehour.slice(0, 5) }}
            </template>
            <template #[`item.addopenhour`]="{ item }">
              {{ item.addopenhour.slice(0, 5) }}
            </template>
            <template #[`item.addclosehour`]="{ item }">
              {{ item.addclosehour.slice(0, 5) }}
            </template>

            <template #item.actions="{ item }">
              <v-btn
                depressed
                block
                style="height: 32px !important"
                color="chip"
                class="text-capitalize ml-2"
                @click="rootStore.editItem(item)"
              >
                Düzenle
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-col>
  </v-row>
</template>

<script>
// Vue
import { computed, onMounted, onUnmounted, ref } from "vue-demi";

// Pinia
import { useRootStore } from "./_store";
import { usePageStore } from "@/stores/pageHeader";

// Components
import AddEdit from "./AddEdit.vue";
import PageHeader from "@/components/PageHeader/Index.vue";

// Icons
import {
  mdiCamera,
  mdiCameraOff,
  mdiClose,
  mdiRoadVariant,
  mdiMagnify,
  mdiUpload,
  mdiTrashCan,
} from "@mdi/js";

export default {
  components: {
    PageHeader,
    AddEdit,
  },
  setup() {
    const rootStore = useRootStore();
    const pageStore = usePageStore();

    // Sayfa Özellikleri
    const pageSettings = () => {
      pageStore.pageTitle = "Root";
      pageStore.pageIcon = mdiRoadVariant;
      pageStore.hasFullScreen = true;
      pageStore.hasDownload = true;
      pageStore.hasDateRangeAll = false;
      pageStore.hasDateRange = false;
      pageStore.hasActions = true;

      pageStore.downloadHeader = {
        "Root No": "rootno",
        "Sipariş Tipi": "mattype",
        "Sipariş Günleri": "orderdays",
        "Açılış Saati": "openhour",
        "Kapanış Saati": "closehour",
        "Ek Açılış Saati": "addopenhour",
        "Ek Kapanış Saati": "addclosehour",
      };
    };

    // Table
    const tableSearchStatus = ref("");
    const tableSearchProfil = ref("");
    const tableSearchUsername = ref("");
    const tableSearchFullname = ref("");
    const tableColumns = computed(() => [
      {
        text: "Root No",
        value: "rootno",
        width: "90px",
        sortable: false,
      },
      {
        text: "Sipariş Tipi",
        value: "mattype",
        width: "150px",
        sortable: false,
      },

      {
        text: "Sipariş Günleri",
        value: "orderdays",
        sortable: false,
      },
      {
        text: "Açılış Saati",
        value: "openhour",
        width: "130px",
      },
      {
        text: "Kapanış Saati",
        value: "closehour",
        width: "130px",
        sortable: false,
      },

      {
        text: "Ek Açılış Saati",
        value: "addopenhour",
        width: "130px",
        sortable: false,
      },
      {
        text: "Ek Kapanış Saati",
        value: "addclosehour",
        width: "130px",
        sortable: false,
      },

      {
        text: "",
        value: "actions",
        align: "right pl-0",
        width: "150",
        sortable: false,
      },
    ]);
    const orderDays = (item) => {
      const textDays = [
        "Pazar",
        "Pazartesi",
        "Salı",
        "Çarşamba",
        "Perşembe",
        "Cuma",
        "Cumartesi",
        "Pazar",
      ];
      const days = item;

      return days.map((item) => textDays[item]);
    };
    onMounted(async () => {
      pageSettings();
      // Yöneticiler Çekiliyor
      const [data, error] = await rootStore.tableFetch();
      if (error) {
        throw new Error(error);
      }
    });

    onUnmounted(() => {
      pageStore.pageSettingsClear();
    });
    return {
      rootStore,
      pageStore,
      // Table
      tableColumns,
      tableSearchStatus,
      tableSearchProfil,
      tableSearchUsername,
      tableSearchFullname,

      orderDays,
      // icons
      icons: {
        mdiCamera,
        mdiCameraOff,
        mdiRoadVariant,
        mdiClose,
        mdiMagnify,
        mdiUpload,
        mdiTrashCan,
      },
    };
  },
};
</script>
